import React from 'react';
import { useSearchParams } from 'react-router-dom';

import TabPanel from 'commons/TabPanel';

import TableActivityLogsRoleArtist from '../../Common/TableActivityLogs';
import TableArtistTagRequest from '../../Common/TableArtistTagRequest';
import TableShowAllRoleArtist from '../../TableArtistPanel/TableShowAllRoleArtist';
import TableShowSoldDonatedRoleArtist from '../../TableArtistPanel/TableShowSoldDonatedRoleArtist';

const TableArtist = () => {
  const [searchParams] = useSearchParams();
  const tabValue = Number(searchParams.get('tab') || 0);

  return (
    <>
      <TabPanel
        value={tabValue}
        index={0}
      >
        <TableShowAllRoleArtist />
      </TabPanel>

      <TabPanel
        value={tabValue}
        index={1}
      >
        <TableShowSoldDonatedRoleArtist />
      </TabPanel>

      <TabPanel
        value={tabValue}
        index={2}
      >
        <TableActivityLogsRoleArtist />
      </TabPanel>

      <TabPanel
        value={tabValue}
        index={3}
      >
        <TableArtistTagRequest />
      </TabPanel>
    </>
  );
};

export default TableArtist;
